import { render, staticRenderFns } from "./generalStationView.vue?vue&type=template&id=773b1836&scoped=true&"
import script from "./generalStationView.vue?vue&type=script&lang=js&"
export * from "./generalStationView.vue?vue&type=script&lang=js&"
import style0 from "./generalStationView.vue?vue&type=style&index=0&id=773b1836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773b1836",
  null
  
)

export default component.exports